import {compose} from '@tkww/orion-web-lib-css-modules';
import React, {createContext, useRef} from 'react';
import PropTypes from 'prop-types';
import {Snackbar} from '@tkww/orion-web-ds-feedback';
import styles from './SnackbarContext.scss';
import noop from '../utils/noop';

const Context = createContext({
  showSnackbar: noop,
  dismissSnackbar: noop,
  showSuccessSnackbar: noop,
});

export default Context;

export const SnackbarContextProvider = ({children}) => {
  const snackbarElement = useRef(null);

  const showSnackbar = (content, dismissTimeout) => {
    snackbarElement.current.showAndDismiss({data: content, dismissTimeout});
  };
  const dismissSnackbar = () => {
    snackbarElement.current.dismiss();
  };
  const showSuccessSnackbar = content => {
    snackbarElement.current.showAndDismiss({
      data: content,
      type: 'success',
    });
  };

  return (
    <Context.Provider
      value={{showSnackbar, dismissSnackbar, showSuccessSnackbar}}>
      <>
        {children}
        <Snackbar
          classes={compose({children: styles['children-container']})}
          ref={snackbarElement}>
          {data => {
            if (data?.type === 'WITH_ACTION') {
              return (
                <div className={styles['action-container']}>
                  {data.text}
                  <a href={data.href} onClick={data.onClick}>
                    {data.linkText}
                  </a>
                </div>
              );
            }

            return data;
          }}
        </Snackbar>
      </>
    </Context.Provider>
  );
};

SnackbarContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
